module.exports = __webpack_public_path__ + "static/media/partners_logos_mobile.e17ad801.png";